

import React, { useEffect, useState } from 'react';
import { ContractWizardConSummary } from './ContractWizardConSummary';
import contractServices from '../Contracts/contractServices';
import { RegionForm } from '../Common/regionForm';
import commonServices from '../Common/commonServices';
import MainWizard from './MainWizard';
import WizardServices from './WizardServices';
import DeleteDialogueBox from 'components/Common/deleteDialogue';

export function ContractWizardRegion(param: any) {

    let [message, setMessage] = useState("");
    let [deleteType, setDeleteType] = useState("");
    let [description, setDescription] = useState("");
    let [activeRegion, setActiveRegion] = useState('');
    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [regionSelected, setregionSelected] = useState('');
    let [groupingArray, setGroupingArray] = useState<any>([]);
    let [systemRegions, setSystemRegions] = useState<any>([]);
    let [territoryCode, setTerritoryCode] = useState<any>([]);
    let [SelectedRegion, setSelectedRegion] = useState<any>([]);
    let [territorySelected, setterritorySelected] = useState<any>([]);
    let [ContractTerritory, setContractTerritory] = useState<any>([]);
    let [contractsregionsTerritories, setcontractsregionsTerritories] = useState<any>([]);

    useEffect(() => {
        setterritorySelected("")
        setregionSelected("")
        apiCall("");

        contractServices.systemRegions().then((res) => {
            systemRegions = res;
            setSystemRegions(systemRegions);
        })

        contractServices.territoryCode().then((res) => {
            territoryCode = res;
            setTerritoryCode(territoryCode);
        })

    }, []);

    const apiCall = (e: any) => {

        if (regionSelected) {
            commonServices.systemTerritoryCode({ regionCode: e }).then((res) => {
                setSelectedRegion(res);
            })
        }

        contractServices.contractsregionsTerritories({ contractRefNum: param?.data?.code?.contractRefNum }).then((res) => {
            setcontractsregionsTerritories(res);
        })

        contractServices.getContractTerritory({ contractRefNum: param?.data?.code?.contractRefNum, territoryCode: e }).then((res) => {
            ContractTerritory = res
            setContractTerritory(ContractTerritory);

            for (var i = 0; i < res.length; i++) {
                console.log(ContractTerritory[i]?.groupingId)

                var filter_val = groupingArray?.filter((value: any) => value == ContractTerritory[i]?.groupingId)

                console.log(filter_val)
                if (filter_val.length == 0) {
                    groupingArray.push(ContractTerritory[i]?.groupingId)
                }

            }

            activeRegion = groupingArray[0]
            setActiveRegion(activeRegion)

            console.log(groupingArray)
            setGroupingArray(groupingArray)

        })

    }

    let [systemTerritoryCode, SetsystemTerritoryCode] = useState<any>([]);
    const Chooseregion = (e: any) => {
        console.log(e.target.value)
        regionSelected = e.target.value
        setregionSelected(regionSelected);
        if (regionSelected.length > 0) {
            setterritorySelected("");
            //apiCall(e.target.value);
            WizardServices?.systemTerritoryCode({ regionCode: e.target.value }).then((respond: any) => {
                systemTerritoryCode = respond
                SetsystemTerritoryCode(systemTerritoryCode)
            })
        }
    }

    const Chooseterritory = (e: any) => {

        var selectedTer = territoryCode?.filter((val: any) => val.territoryName == e.target.value)
        console.log(e.target.value)
        console.log(selectedTer)
        territorySelected = selectedTer[0]
        setterritorySelected({ ...territorySelected });

        console.log(territorySelected)
        if (territorySelected.length > 0) {
            setregionSelected("");
            //apiCall(e.target.value);
        }
    }


    const [contractType, setcontractType] = useState(2)
    const [asDefault, setAsDefault] = useState<any>([]);
    const addRegion = () => {
        var payload = {
            contractRefNum: param?.data?.code?.contractRefNum,
            contractType: contractType,
            groupingId: regionSelected,
            ...(asDefault?.territoryCode && { territoryCode: asDefault.territoryCode })
        }
        WizardServices.regionterritoriesSave(payload)
        console.log(payload)
    }

    const addTerritory = () => {
        var payload = {
            contractRefNum: param?.data?.code?.contractRefNum,
            contractType: contractType,
            groupingId: "",
            territoryCode: territorySelected?.territoryCode
        }
        WizardServices.regionterritoriesSave(payload)
    }

    const saveDefaultRegion = (regionsTerritories: any) => {

        var payload = {
            groupingId: regionsTerritories?.groupingId,
            contractRefNum: regionsTerritories?.contractRefNum,
            defaultTerritoryCode: regionsTerritories?.territoryCode
        }
        console.log(regionsTerritories)
        WizardServices.saveDefaultRegion(payload)
    }

    const deleteRateRegion = (type: any, data: any) => {

        console.log(type)
        console.log(data)
        deleteType = type
        setDeleteType(deleteType)
        deleteData = data
        setDeleteData(deleteData)
        deleteStatus = true;
        setDeleteStatus(deleteStatus)

        if (type == "Rate") {
            description = data?.groupDesc + " will be deleted from the whole contract."
            description = description + "<p>NOTE: It is a good idea to export your contract before you delete a region as you can then see the setup of the contract before you delete all associated rates, reserves and adjustments.</p>"
            setDescription(description);

            message = "continue"
            setMessage(message)
            apiCall("");
        } else {
            description = ""
            setDescription(description)
            message = "delete territory " + data?.territoryName
            setMessage(message);
            apiCall("");
        }

    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {
            //uploadDelete();
            if (deleteType == "Rate") {
                console.log(deleteType)
                WizardServices.deletesystemTerritory(deleteData)
            }

            if (deleteType == "Region") {
                console.log(deleteType)
                WizardServices.deletesystemTerritory(deleteData)
            }

        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    return (

        <>
            <div className="ws-12  box landing">

                <div className="box-header">  <h2 className='text-bold'>Contract Region</h2>  </div>

                <div className='ws-12 pull-left pLarge'>

                    <div className='ws-12 box pm'>
                        <div className="form-format">
                            <div className="label-entries ws-4">
                                <select className="ws-4 full-width full-height" onChange={Chooseregion}>
                                    <option value="" >Choose region</option>
                                    {
                                        systemRegions.map((data: any) => {
                                            return (
                                                <option value={data.groupingId}> {data.groupDesc}</option>
                                            )
                                        })
                                    }

                                </select>
                            </div>

                            <div className="label-entries ws-4"> <RegionForm param={param?.data?.code} /> </div>

                            <div className="label-entries ws-4 ">
                                <select className="ws-4 full-width full-height" onChange={Chooseterritory}>
                                    <option value="" >Choose territory</option>
                                    {
                                        territoryCode.map((data: any) => {
                                            return (
                                                <option value={data.territoryName}> {data.territoryName}</option>
                                            )
                                        })
                                    }
                                </select>

                            </div>
                        </div>

                        {/**territory */}
                        {(regionSelected.length > 0)}
                        {(regionSelected.length > 0) && <div className="ws-12">

                            <div className="box-header well" data-ng-show="filteredRegionTerritoryList.length > 0">
                                <h2>  <span >{regionSelected} record(s) found</span> </h2>
                            </div>

                            <div className="box-content">
                                <div className="alert alert-info hide">No territories have been associated with this region </div>

                                <div className="ws-12">
                                    {(systemTerritoryCode.length > 0) && <table className="table noBorder" >
                                        <thead>
                                            <tr>
                                                <th >Region</th>
                                                <th >Territory</th>
                                                <th >Set as default</th>
                                            </tr>

                                        </thead>
                                        <tbody>

                                            {
                                                systemTerritoryCode?.map((values: any) => {
                                                    return (

                                                        <tr>
                                                            <td >{values.groupDesc}</td>
                                                            <td >{values.territoryName}</td>
                                                            <td>
                                                                <input type="radio" ng-model="setDefault" name="setDefault" value="MU" onChange={() => setAsDefault(values)} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                            <tr>
                                                <td>
                                                    <label>
                                                        <input type="radio" name="contractType" checked={contractType == 1} onChange={() => setcontractType(1)} value="1" /> <span >Profit Sharing</span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <label>
                                                        <input type="radio" name="contractType" checked={contractType == 2} onChange={() => setcontractType(2)} value="2" /> <span >Points based</span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <label>
                                                        <input type="radio" name="contractType" checked={contractType == 3} onChange={() => setcontractType(3)} value="3" /> <span >Service based</span>
                                                    </label>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>}
                                </div>

                            </div>

                            {(regionSelected.length > 0) && <div className="box-footer">
                                <button onClick={addRegion} className="icon-btn edit btn-sm height35 width80">Region</button>
                            </div>}

                        </div>}

                        {/** territorySelected selected */}
                        { }
                        {(territorySelected.length > 0)}
                        {(territorySelected?.territoryCode) && <div className="ws-12">

                            <div className="box-content">

                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>Territory</th>
                                            <th >Code</th>
                                        </tr>

                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td colSpan={2}>{territorySelected?.territoryName}</td>
                                            <td >{territorySelected?.territoryCode}</td>
                                        </tr>

                                        <tr>
                                            <td >&nbsp;</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <label>
                                                    <input type="radio" name="contractType" checked={contractType == 1} onChange={() => setcontractType(1)} value="1" /> <span >Profit Sharing</span>
                                                </label>
                                            </td>
                                            <td>
                                                <label>
                                                    <input type="radio" name="contractType" checked={contractType == 2} onChange={() => setcontractType(2)} value="2" /> <span >Points based</span>
                                                </label>
                                            </td>
                                            <td>
                                                <label>
                                                    <input type="radio" name="contractType" checked={contractType == 3} onChange={() => setcontractType(3)} value="3" /> <span >Service based</span>
                                                </label>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            <div className="box-footer">
                                <button onClick={addTerritory} className="icon-btn edit btn-sm ">  Territory </button>
                            </div>

                        </div>}
                    </div>

                    {/**territory and region selected */}
                    <div className='ws-12 pt'>

                        {groupingArray.length == 0 && <div className="alert alert-info">No regions has been associated with this current contract yet. </div>}

                        {/**record selected */}
                        <div className='ws-12 mt box'>
                            <div className="box box-header">
                                <span>
                                    <i className="fa fa-table"></i>
                                    <span >{ContractTerritory.length} record(s) found</span>
                                </span>
                            </div>

                            <div className="ws-12 nav pLarge">
                                {
                                    groupingArray?.map((val: any) => {
                                        return (
                                            <button className={activeRegion == val ? "width50 icon-btn info fill" : "width50 icon-btn info"} onClick={() => setActiveRegion(val)}>
                                                {val}
                                            </button>
                                        )
                                    })
                                }

                                <div className="ws-12 allowVscroll mt">
                                    {ContractTerritory.length > 0 && <table className="newTable">
                                        <thead>
                                            <tr>
                                                <th className='text-bold'>Region ID</th>
                                                <th className='text-bold'>Region</th>
                                                <th className='text-bold'>Territory ID</th>
                                                <th className='text-bold'>Territory</th>
                                                <th className='text-bold'>Default</th>
                                                <th className='text-bold'>Basis</th>
                                                <th className='text-bold'>Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                contractsregionsTerritories?.map((values: any) => {

                                                    if (values.groupingId == activeRegion) {
                                                        return (
                                                            <tr>
                                                                <td>{values?.groupingId}</td>
                                                                <td>{values?.groupDesc}</td>
                                                                <td>{values?.territoryCode}</td>
                                                                <td>{values?.territoryName}</td>
                                                                <td>{values?.defaultTerritory}</td>
                                                                <td>{values?.basis}</td>
                                                                <td className='forceSingleLine'>
                                                                    <a className="icon-btn delete" title='Region' onClick={() => deleteRateRegion("Region", values)}><i className="icon-trashcan"></i></a>
                                                                    <a className="icon-btn delete" title='Rate' onClick={() => deleteRateRegion("Rate", values)}><i className="icon-trashcan"></i></a>
                                                                    <a className="icon-btn edit" onClick={() => saveDefaultRegion(values)}><i className="icon-save-disk"></i></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }

                                                })
                                            }
                                        </tbody>
                                    </table>}
                                </div>

                                {ContractTerritory.length == 0 && <div className="alert alert-info" data-ng-show="contractRegionTerritoriesFilterred.length == 0">
                                    No records to display
                                </div>}
                            </div>
                        </div>
                    </div>

                </div>

                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={deleteStatus} description={description} message={message} onChange={deleteConfirmation} />
                        }
                    })()
                }

            </div>
        </>

    );
}
